import { render, staticRenderFns } from "./CustomerContacts.vue?vue&type=template&id=78d58083&scoped=true"
import script from "./CustomerContacts.vue?vue&type=script&lang=js"
export * from "./CustomerContacts.vue?vue&type=script&lang=js"
import style0 from "./CustomerContacts.vue?vue&type=style&index=0&id=78d58083&prod&scoped=true&lang=css"
import style1 from "./CustomerContacts.vue?vue&type=style&index=1&id=78d58083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d58083",
  null
  
)

export default component.exports